import React, { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, Box, TextField, Button,
} from '@mui/material';
import sendRequest from '../utils/sendRequest';
import { SubmitButton, CancelButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function AddInvoiceDialog({ po_doc_id, poName, addSnackbar, fetchPoDetails=null, closeMoreActions }) {
  const [open, setOpen] = useState(false);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [invoiceLink, setInvoiceLink] = useState("");

  const handleOpen = () => {
    setInvoiceLink("");
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingInvoice) {
      setInvoiceLink("");
      setOpen(false);
      closeMoreActions();
    }
  };

  const addInvoice = async (invoiceLink) => {
    setLoadingInvoice(true);
    try {
      let response = await sendRequest(`purchase-orders/add-invoice?po_doc_id=${po_doc_id}&invoice_link=${invoiceLink}`);
      addSnackbar(response.message);
      handleClose();
      if (fetchPoDetails) fetchPoDetails();
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingInvoice(false);
    }
  }

  return (
    <Box>
      <Button variant="text" onClick={handleOpen}>Add Invoice</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingInvoice}
      >
        <CustomDialogTitle
          header={"Add Invoice link to records"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            Add link to order invoice document
          </DialogContentText>
          <TextField
              autoComplete="off"
              autoFocus
              required
              margin="dense"
              id="invoiceLink"
              name="invoiceLink"
              label="Document link"
              type="text"
              fullWidth
              variant="standard"
              onChange={(e) => setInvoiceLink(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingInvoice}>Cancel</CancelButton>
          <SubmitButton
            showSpinner={loadingInvoice}
            text={"Add Invoice"}
            onClick={() => addInvoice(invoiceLink)}
            disabled={!invoiceLink.trim()}
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}